import React from 'react';
import _ from 'lodash';
import { getMappedV3Data } from 'common/services/metrics.service';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { mapCycleTimeStatisticsToPipelineMilestones } from 'components/DeliveryPipeline';
import { metricNames } from '@linearb/linjs-common';
import CycleTime from '../../components/CycleTime';
import {
  createTrendDataV3,
  getCycleTimeConfigurations,
  goToBranchesOrderBy
} from '../../dashboard.service';
import { getFormattedV3Data } from '../groupDashboard.service';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';
import useBenchmarkOrgSizeConfig from 'views/root/views/home/hooks/useBenchmarkOrgSizeConfig';
import useGroupMetricsTrend from '../hooks/useGroupMetricsTrend/useGroupMetricsTrend';
import { useSelector } from 'react-redux';
import { isIterationsPeriodKeySelectedSelector } from 'state/selectors/ui-state';

const GroupCycleTime = ({
  toggleModal,
  uiState,
  history,
  current5Iterations,
  selectedGroup,
  metrics
}) => {
  const { dates } = uiState;
  const isIterationsPeriod = useSelector(isIterationsPeriodKeySelectedSelector);
  const metricsByGroup = _.keyBy(metrics, 'group');
  const selectedGroupId = _.get(selectedGroup, '[0].id');
  const v3DataResult = _.get(
    metricsByGroup,
    `[${selectedGroupId}].data[0]`,
    {}
  );
  const mappedV3Data = getMappedV3Data({ v3DataResult });
  const formattedV3Data = getFormattedV3Data(mappedV3Data);
  const metricsCalculationConfig = useMetricsCalculationConfig();
  const { metricsCalculationStrategy } = metricsCalculationConfig;
  const { benchmarkOrgSize } = useBenchmarkOrgSizeConfig();
  const { metricsTrend } = useGroupMetricsTrend({
    dates,
    metricsCalculationStrategy,
    selectedGroup,
    current5Iterations,
    isIterations: isIterationsPeriod
  });
  const groupTrendData = metricsTrend.filter(
    ({ group }) => group === selectedGroupId
  );
  const { xData, yCycleTimeData } = createTrendDataV3(
    groupTrendData,
    current5Iterations,
    metricsCalculationConfig,
    benchmarkOrgSize
  );
  return (
    <>
      <CycleTime
        toggleModal={toggleModal}
        value={mappedV3Data[metricNames.CYCLE_TIME]}
        trendData={{ x: xData, y: yCycleTimeData }}
        selectedTeamId={selectedGroupId}
        onLinkIconClick={() => {
          TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
            page: TRACKING.PAGES.DASHBOARD,
            click_type: TRACKING.CLICK.CYCLE_TIME_CONTEXT
          });
          goToBranchesOrderBy(
            'cycle_time,desc',
            uiState,
            selectedGroup[0],
            history,
            metricNames.CYCLE_TIME,
            'cycle_time_updated'
          );
        }}
        configurations={getCycleTimeConfigurations(
          mapCycleTimeStatisticsToPipelineMilestones(
            mappedV3Data,
            {},
            metricsCalculationConfig,
            benchmarkOrgSize
          ),
          true
        )}
        avgTime={formattedV3Data[metricNames.CYCLE_TIME]}
        dates={dates}
      />
    </>
  );
};

export default GroupCycleTime;
